import './search-page/search-page'


// WEBPACK FOOTER //
// ./src/js/pages/search-page.js